import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import { REM_CONFIG } from "@/utils/fontSize";
const InventoryDisplay = ({ className = "", data, }) => {
    const defaultData = [
        {
            title: "本年计划",
            lignin: 8886,
            dryPowder: 15356,
            finishedProduct: 66870,
        },
        {
            title: "本月加工",
            lignin: 738.83,
            dryPowder: 1279.67,
            finishedProduct: 5572.5,
        },
        {
            title: "本年累计",
            lignin: 6280,
            dryPowder: 10621.26,
            finishedProduct: 49038,
        },
        {
            title: "年完成率",
            lignin: "70.83%",
            dryPowder: "69.17%",
            finishedProduct: "73.33%",
        },
    ];
    const inventoryData = data || defaultData;
    return (_jsxs("div", { className: `
    relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
       
        flex flex-col 
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u8BA1\u5212\u5B8C\u6210\u7387" }), _jsx("div", { className: "flex-1 min-h-0", children: _jsxs("div", { className: "w-full bg-gradient-to-r from-[rgba(7,35,77,0.6)] to-[rgba(6,53,105,0.8)]  overflow-hidden", children: [_jsxs("div", { className: "grid grid-cols-4 bg-[rgba(20,40,80,0.5)] py-[0.14rem]", children: [_jsx("div", { className: "col-span-1 text-left px-[0.03rem]" }), _jsx("div", { className: "col-span-1 text-center text-cyan-300 text-[0.13rem]", children: "\u6728\u8D28\u7D20(\u5428)" }), _jsx("div", { className: "col-span-1 text-center text-cyan-300 text-[0.13rem]", children: "\u8418\u7CFB\u805A\u5408\u7269(\u5428)" }), _jsx("div", { className: "col-span-1 text-center text-cyan-300 text-[0.13rem]", children: "\u6DFB\u52A0\u5242(\u5428)" })] }), inventoryData.map((item, idx) => (_jsxs("div", { className: `
                grid grid-cols-4 
                border-b border-[rgba(255,255,255,0.1)] 
                py-[0.14rem]
                ${idx % 2 === 0
                                ? "bg-gradient-to-r from-[rgba(15,30,63,0.6)] to-[rgba(6,33,69,0.3)]"
                                : "bg-gradient-to-r from-[rgba(7,35,77,0.6)] to-[rgba(6,53,105,0.8)]"}
              `, children: [_jsxs("div", { className: "col-span-1 text-left flex items-center whitespace-nowrap px-[0.03rem]", children: [_jsx("span", { style: {
                                                display: "inline-block",
                                                width: "0.06rem",
                                                height: "0.06rem",
                                                backgroundColor: "#22d3ee", // 亮青色，确保与背景对比
                                                borderRadius: "50%",
                                                marginRight: "0.08rem",
                                                flexShrink: 0, // 防止被压缩消失
                                            } }), _jsx("span", { className: "text-white ", style: {
                                                fontSize: REM_CONFIG.fontSize.small,
                                            }, children: item.title })] }), _jsx("div", { className: "col-span-1 flex items-center justify-center text-white", style: {
                                        fontSize: REM_CONFIG.fontSize.small,
                                    }, children: item.lignin }), _jsx("div", { className: "col-span-1 flex items-center justify-center text-white", style: {
                                        fontSize: REM_CONFIG.fontSize.small,
                                    }, children: item.dryPowder }), _jsx("div", { className: "col-span-1 flex items-center justify-center text-white", style: {
                                        fontSize: REM_CONFIG.fontSize.small,
                                    }, children: item.finishedProduct })] }, idx)))] }) })] }));
};
export default InventoryDisplay;
